var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mv-page',[_c('mv-default-row',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',[_vm._v("Страница не найдена 404 :(")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }